if (!customElements.get('jl-card-image-preview-v2')) {
  customElements.define('jl-card-image-preview-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const start = () => {
        const model = this.querySelector('[data-model-image] img');
        if (!model) return false;
        this.waiter?.disconnect();
        this.initialize(model);
        return true;
      };
      if (!start()) {
        this.waiter = new MutationObserver(start);
        this.waiter.observe(this, { childList: true, subtree: true });
      }
    }
    initialize(model) {
      const signal = this.controller.signal;
      const card = this.closest('product-card') || this;
      this.hovering = this.touching = this.focusing = false;
      let ready = false;
      const refresh = () => this.toggleAttribute('previewing', ready && (this.hovering || this.touching || this.focusing));
      const reset = () => { this.hovering = this.touching = this.focusing = false; refresh(); };
      const prepare = async () => {
        if (!model.complete || model.naturalWidth === 0) return;
        try { await model.decode?.(); } catch { return; }
        if (signal.aborted) return;
        ready = model.naturalWidth > 0;
        this.toggleAttribute('data-preview-ready', ready);
        this.removeAttribute('data-preview-unavailable');
        refresh();
      };
      model.addEventListener('load', prepare, { signal });
      model.addEventListener('error', () => {
        ready = false;
        this.removeAttribute('data-preview-ready');
        this.setAttribute('data-preview-unavailable', '');
        refresh();
      }, { signal });
      card.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovering = true; refresh(); }
      }, { signal, passive: true });
      card.addEventListener('pointerleave', () => {
        this.hovering = this.touching = false;
        refresh();
      }, { signal, passive: true });
      card.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse') { this.touching = true; refresh(); }
      }, { signal, passive: true });
      window.addEventListener('pointerup', () => { this.touching = false; refresh(); }, { signal, passive: true });
      window.addEventListener('pointercancel', reset, { signal, passive: true });
      window.addEventListener('blur', reset, { signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) reset(); }, { signal });
      card.addEventListener('focusin', event => {
        if (event.target.matches?.(':focus-visible')) { this.focusing = true; refresh(); }
      }, { signal });
      card.addEventListener('focusout', event => {
        if (!card.contains(event.relatedTarget)) { this.focusing = false; refresh(); }
      }, { signal });
      reset();
      prepare();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.waiter?.disconnect();
      this.controller = null;
      this.removeAttribute('previewing');
      this.removeAttribute('data-preview-ready');
      this.removeAttribute('data-preview-unavailable');
    }
  });
}
